export default "__VITE_ASSET__40ad9d50__"